const config = {
    baseUrl:'/',
    imgSiteUrl:'http://test.sozdata.com/',
    GeneralPath:'/',
    siteTitle:'知图平台',
    weChatUrl:'http://public.sozdata.com/',
    personUploadImage:'main/person/uploadPersonImage',
    personUploadImage2Pub:'con/question/uploadQuestionImage',
    uploadLoginImage:'/main/person/uploadLoginImage',
    primaryColor:'#e75934',
    domain:'sozdata.com'
    // domain:''
}
export default config;